import s from './BuyExperiences.module.scss';
import { ExperienceCard } from './ExperienceCard';
import { getHeading } from './helpers';

export { getHeading };

export default function BuyExperiences({ experiences, ribbonType }) {
  return (
    <div className={s.wrapper}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className={s.heading}>{getHeading(experiences)}</div>
            <div className={s.body}>
              <div className="row">
                {experiences.map((experience, index) => (
                  <ExperienceCard
                    key={`${experience.type}-${index}`}
                    experience={experience}
                    ribbonType={ribbonType}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
